$(document).ready(function () {
  $(document).on('click', '#open-main-drawer', function (e) {
    e.preventDefault();
    const printerId = $(this).data('printer-id');
    const printerName = $(this).data('printer-name');
    const printerIpAddress = $(this).data('printer-ip-address');
    const printerType = $(this).data('printer-type');
    const mainDeviceId = $(this).data('main-device-id');
    const currentDeviceId = localStorage.getItem('deviceID') || null;

    if (!printerId) {
      return;
    }

    if (window.ReactNativeWebView) {
      const message = {
        action: 'open_drawer',
        printer: {
          printer_id: printerId,
          name: printerName,
          ip_address: printerIpAddress,
          type: printerType,
        },
      };

      if (mainDeviceId === currentDeviceId) {
        console.log('Sending message to React Native WebView:', message);
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
      } else {
        socket.send(
          JSON.stringify({
            type: 'open_drawer',
            main_pos_device_id: mainDeviceId,
            message: message,
          })
        );
      }
    }
  });
});
